import React from 'react';
import Navlink from './nav-links/navlink';
import BottomNavLink from '../desktop/nav-links/navlink';
import Social from '../common/social/social';
import SubFooter from '../common/sub-footer/sub-footer';
import { IFooterProps } from '../IFooter';
import QuickLink from '../../../basic/quickLink';
import Image from '../../../basic/image';
import { DataAnalyticsLocations, DataAnalyticsTypes, buildAnalytics } from '../../../basic/analytics';
import { useContent } from '../../../../providers/content/hook';

const MobileFooter = ({ footerProps, className }: IFooterProps): JSX.Element => {
  const { mainNavigation, social, disclaimer, subFooter,siteFooterlogo, bottomNavigationLinks } = footerProps || {};
  const { content } = useContent();
  return (
    <div className={className}>
      <div className={`container-none py-md  ${className} bg-[#003b71]`}>
      
        <div className="container flex w-5/6 flex-col mx-auto">
          {mainNavigation && <Navlink navlinks={mainNavigation} />}
          
        </div>
      </div>
      <div className="container-none py-md bg-[#0d1c3d]">
        <div className="bg-[#0d1c3d] container flex w-5/6 flex-col mx-auto">
          {siteFooterlogo && siteFooterlogo.url && (
              <div className='flex items-center w-[220px] h-auto justify-center'>
                <QuickLink href="/" role="" dataAnalytics={buildAnalytics(DataAnalyticsLocations.Footer, DataAnalyticsTypes.Media)}>
                  <Image alt={content?.header?.alternate_text} src={siteFooterlogo.url} layout="responsive" />
                </QuickLink>
              </div>
            )}
            <div className="pt-4">
            {bottomNavigationLinks && <BottomNavLink navlinks={bottomNavigationLinks} disclaimer={disclaimer} section="bottom" />}
          </div>
          <div className="pt-2">
            {social && <Social socialItems={social} disclaimer={disclaimer} />}
          </div>
          <div className="container flex flex-row">
            {subFooter && <SubFooter items={subFooter} />}
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default MobileFooter;
